import { ApolloError, useQuery } from '@apollo/client';
import { GET_ACCOUNT_SETTINGS_INFO } from 'pages/settings/components/account-settings/account-settings.api';

export interface HookReturnType {
  data?: GetAccountSettingsInfoQuery;
  loading: boolean;
  error?: ApolloError;
}

export const useAccountSettings = (accountId: number): HookReturnType => {
  const { data, loading, error } = useQuery(GET_ACCOUNT_SETTINGS_INFO, {
    variables: { accountId },
  });

  return {
    data,
    loading,
    error,
  };
};
